module.exports = __webpack_public_path__ + "img/sipur_no.f4a9baae.png";